
import React from "react";
import { CheckCircle } from "lucide-react";

const whatsappLeadsData = [
  {
    heading: "Showcase Your Menu and Food Products on WhatsApp",
    points: [
      "Use WhatsApp broadcasts to highlight your restaurant’s menu and online food items.",
      "Quickly promote new dishes and seasonal specials to grab attention.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Restaurant/restaurant_and_food_2.png",
  },
  {
    heading: "Make Dining Reservations Simple with WhatsApp",
    points: [
      "Answer questions about your restaurant, hours, and menu options via WhatsApp.",
      "Collect contact info to follow up on table bookings and pre-orders for a great dining experience.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Restaurant/restaurant_and_food_3.png",
  },
  {
    heading: "Help Customers Order Faster with WhatsApp Support",
    points: [
      "Respond to dine-in or online order inquiries in real time using WhatsApp.",
      "Set up automated FAQs to guide customers and improve their ordering experience.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Restaurant/restaurant_and_food_4.png",
  },
  {
    heading: "Process Payments Quickly on WhatsApp",
    points: [
      "Give customers an easy way to pay for their orders directly in WhatsApp.",
      "Send payment links via the WhatsApp Business API for fast and secure transactions.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Restaurant/restaurant_and_food_5.png",
  },
  {
    heading: "Keep Customers Updated with Order Tracking",
    points: [
      "Send real-time updates on order status to keep customers informed.",
      "Use WhatsApp with ChatMitra to automate delivery notifications and ease post-purchase worries.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Restaurant/restaurant_and_food_6.png",
  },
  {
    heading: "Encourage Repeat Orders to Build Loyalty",
    points: [
      "Reconnect with customers using their order history on WhatsApp.",
      "Launch campaigns with discounts on their favorite dishes to win their loyalty.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Restaurant/restaurant_and_food_7.png",
  },
  {
    heading: "Handle Returns and Refunds Smoothly on WhatsApp",
    points: [
      "Address issues like incorrect or unsatisfactory orders quickly.",
      "Verify details and process returns or refunds instantly through WhatsApp chats.",
    ],
    // buttonText: "Get Start ",
    buttonText: "Meta Policy for Food",
    buttonLink:"https://transparency.meta.com/en-gb/policies/community-standards/restricted-goods-services/",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Restaurant/restaurant_and_food_8.png",
  },
  {
    heading: "Gather Feedback and Reviews via WhatsApp",
    points: [
      "Follow up after deliveries to ask for reviews and suggestions.",
      "Use interactive WhatsApp messages with ChatMitra to collect valuable customer insights.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Restaurant/restaurant_and_food_9.png",
  },
  {
    heading: "Simplify Curbside Pickup and Takeaway Orders",
    points: [
      "Let customers order and pick up at their convenience using WhatsApp.",
      "Send order status updates and pickup schedules for a smooth process.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Restaurant/restaurant_and_food_10.png",
  },
];

const Restaurantcycle = () => {
  return (
    <>
      <div className="h-64 bg-[#075E54] flex justify-center items-center px-4 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[#075E54] via-[#087357] to-transparent opacity-90"></div>
        <div className="relative z-10 text-center max-w-3xl px-6">
          <h1 className="text-3xl font-semibold text-white leading-relaxed">Manage Everything from Menu Promotion to Deliveries on WhatsApp with ChatMitra</h1>
          <div className="w-16 h-1 bg-white my-4 mx-auto rounded-full"></div>
          <p className="text-white text-opacity-80 text-sm">Make customer interactions quick, engaging, and effective for your restaurant.</p>
        </div>
        <div className="absolute top-0 left-0 w-16 h-1 bg-white opacity-50 rotate-45"></div>
        <div className="absolute bottom-0 right-0 w-20 h-1 bg-white opacity-50 -rotate-45"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-20">
        {whatsappLeadsData.map((item, index) => (
          <div key={index} className={`flex flex-col lg:flex-row items-center gap-16 my-20 ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
            <div className="w-full lg:w-1/2">
              <img src={item.image} alt={item.heading} className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">{item.heading}</h2>
              <ul className="space-y-4 text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
               <a
               href={item.buttonLink}
               className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
             >
               {item.buttonText}
             </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Restaurantcycle;